/*
  /* Project: HIVE
  /* Desc: This page is used for showing the onboarding candidates from fresher and Experience.
  /* Author:Nivetha M
 */

//PC_O_01
//Required packages are imported
import { useEffect, useState } from 'react';
import React from 'react';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import Select from 'react-select';
// import Tooltip from './Tooltip';
// import { Tooltip } from 'react-tooltip';
import { Tooltip } from 'antd';
import Popupp from '../components/ConformationPopup/Popup';
import {
    getFilterData,
    getOnboardingCandidate,
    getSearchData,
    getSortData,
    updateHold,
    updateHoldOnboarding,
    updateOnboardingDate,
    updateJoiningDate,
    updateMarkAsNotJoin,
    sendMail,
    postEntity,
    getEntityId,
    postStage,
    postHireStage,
    postHireTimeline,
    getCollegeDetail,
} from '../service/RecruiterApi';
import moment from 'moment';
import Popup from './popup';
import JoinPopup from './JoinPopup';
import BreadCrumbs from './BreadCrumbs/BreadCrumbs';
import { encryptStorage } from '../constant';
import { useNavigate } from 'react-router-dom';
import OnboardingPopupGrid from './OnboardingPopupGrid';
import ReactSelect from 'react-select';

/**
 * PS_01 -- when user clicks on onboarding from the application
 */
function Onboarding() {
    //These are the variable for showing breadcrumb in the top of the page
    let breadCrumbsData = [
        { title: 'Dashboard', path: '/overview', isActive: true },

        { title: 'Onboarding', path: '/Onboarding', isActive: false },
    ];
    let sortIcon = {
        id: 'desc',
        job_position: 'desc',
        first_name: 'desc',
        document_verification: 'desc',
        annual_ctc: 'desc',
        on_boarding_date: 'desc',
        joining_date: 'desc',
        on_boarding_date: 'desc',
        offerletter_status: 'desc',
        status: 'desc',
        job_source_name: 'desc',
    };
    //PC_O_02
    //Create the state variable for the onboarding Grid
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [reason, setReason] = useState('');
    let UserName = encryptStorage.getItem('username');
    const [OnboardingCandidate, setOnboardingCandidate] = useState([]);
    let GridLoadarray = [];
    const [gridData, setGridData] = useState(GridLoadarray);
    const [isLoading, setIsLoading] = React.useState(true);
    const [columnName, setColumnName] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [columnSearch, setColumnSearch] = useState('');
    const [count, setCount] = useState();
    const [searchValue, setSearchValue] = useState();
    const [hideSortIcon, setHideSortIcon] = useState(sortIcon);
    const [status, setStatus] = useState('');
    const [onboardingStatus, setonboardingStatus] = useState('');
    const [joiningStatus, setjoiningStatus] = useState('');
    const [notJoiningReason, setNotJoiningReason] = useState('');
    const [ctc, setCtc] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [docStatus, setDocStatus] = useState('');
    const [offerStatus, setOfferStatus] = useState('');
    const [source, setSource] = useState('');
    const [checkArray, setCheckArray] = useState([]);
    const [allCheck, setallCheck] = useState(false);
    const [empId, setEmpId] = useState([]);
    const [hideBar, setHideBar] = useState(true);
    const [JoiningDateFlag, setJoiningDateFlag] = useState(false);
    const [unholdflag, setunholdFlag] = useState(false);
    const [holdflag, setholdFlag] = useState(true);
    const [gridDataCount, setGridDataCount] = useState(0);

    const [OnboardFlag, setOnboardFlag] = useState(false);
    const [addFlag, setaddFlag] = useState(false);
    const [sample, setSample] = useState(false);
    const navigate = useNavigate();
    const [collegeDropdown, setCollegeDropdown] = useState([]);
    const [selectedColleges, setSelectedColleges] = useState([]);
    const [filterShow, setFilterShow] = useState(false)
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [filteredCount, setFilteredCount] = useState(0);

    //PC_O_03
    //In the on load of the page,useEffect method is called.
    useEffect(() => {
        if (encryptStorage.getItem('groupid') == 1) {
            getOnboardingDetails();
            getCollegeDD();
            getOnboardingCandidate();
        } else {
            navigate('/', { state: { hideNav: false } });
        }
    }, []);

    //PC_O_04
    //Getting the onboarding candidates from the db and show it in the grid.
    /**
     * PS_02 -- getOnboardingDetails() function gets triggered, and getOnboardingCandidate is called
     */
    const getOnboardingDetails = () => {
        try {
            getOnboardingCandidate().then((res) => {
                if (res.data.Success == true) {
                    setOnboardingCandidate(res.data.ResponseData[0]);
                    setGridDataCount(res.data.ResponseData[0].length);
                    setFilteredCount(res.data.ResponseData[0].length);
                }
            });
        } catch (e) {
            throw e;
        }
    };
    // const handleCollegeChange = (selectedOptions) => {
    //     setSelectedColleges(selectedOptions);
    // };
    const handleCollegeChange = (selectedOptions) => {
        setSelectedColleges(selectedOptions.map(option => ({ college_abbreviation: option.value })));
    };

    const collegeOptions = collegeDropdown.map(college => ({
        value: college.college_abbreviation,
        label: college.college_abbreviation
    }));

    const getCollegeDD = () => {
        try {
            getCollegeDetail().then((res) => {
                if (res.data && res.data.data && Array.isArray(res.data.data)) {
                    setCollegeDropdown(res.data.data);
                } else {
                    console.error("Unexpected data structure:", res);
                }
            }).catch(error => {
                console.error("Error in API call:", error);
            });
        } catch (e) {
            throw e;
        }
    };
    // const handleCollegeDD = (option) => {
    //     setSelectedOptions(option);
    // };


    // const collegeDD = [
    //     { value: 'college1', label: 'College 1' },
    //     { value: 'college2', label: 'College 2' },
    //     { value: 'college3', label: 'College 3' },
    // ];

    const handleSelect = (event) => {
        const selectedValue = event.target.value;
        if (selectedValue) {
            const selected = collegeDropdown.find(college => college.college_abbreviation === selectedValue);
            setSelectedColleges([...selectedColleges, selected]);
            event.target.value = ''; // Reset select after choosing
        }
    };

    const handleRemove = (collegeToRemove) => {
        setSelectedColleges(selectedColleges.filter(college => college !== collegeToRemove));
    };
    //PC_AB_01,PC_AB_02
    const [candidateRecords, setCandidateRecords] = useState([])
    const [checkBoxCount, setCheckBoxCount] = useState()

    const [checkedIds, setCheckedIds] = useState([]);


    const [selectedCandidates, setSelectedCandidates] = useState([]);

    let handleCheckbox = (e, index) => {
        try {
            let newSelectedCandidates = [...selectedCandidates];
            let newCheckedIds = [...checkedIds];

            if (e.target.name == 'all') {
                if (allCheck == true) {
                    let checkboxArray = new Array(OnboardingCandidate.length).fill(false);
                    setCheckArray(checkboxArray);
                    setCheckedIds([]);
                    setHideBar(true);
                    setCount(0);
                    newSelectedCandidates = [];
                } else {
                    let checkboxArray = new Array(OnboardingCandidate.length).fill(false);
                    setCheckArray(checkboxArray);
                    const allIds = OnboardingCandidate.map(candidate => candidate.id);
                    setCheckedIds(allIds);
                    setHideBar(false);
                    setCount(OnboardingCandidate.length);
                    newSelectedCandidates = [...OnboardingCandidate];
                }
                setallCheck(!allCheck);
            } else {
                let singleCheckAction = [];
                let array = checkArray;
                array[index] = !array[index];
                setCheckArray(array);
                const candidateId = OnboardingCandidate[index].id;
                let newCheckedIds;
                if (checkedIds.includes(candidateId)) {
                    newCheckedIds = checkedIds.filter(id => id !== candidateId);
                    newSelectedCandidates = selectedCandidates.filter(candidate => candidate.id !== candidateId);
                } else {
                    newCheckedIds = [...checkedIds, candidateId];
                    newSelectedCandidates = [...selectedCandidates, OnboardingCandidate[index]];
                }
                setCheckedIds(newCheckedIds);

                if (newCheckedIds.length > 0) {
                    setHideBar(false);
                } else {
                    setHideBar(true);
                }
                setallCheck(newCheckedIds.length === OnboardingCandidate.length);
                setCount(newCheckedIds.length);
            }

            // Update selectedCandidates state
            setSelectedCandidates(newSelectedCandidates);

            // Update flags
            let onflag = false;
            let onjoin = false;
            let unhold = false;
            for (let candidate of newSelectedCandidates) {
                if (candidate.status === 'Hold') {
                    unhold = true;
                }
                if (
                    !candidate.on_boarding_date &&
                    candidate.offerletter_status == 'Offer Accepted' &&
                    candidate.status !== 'Hold'
                ) {
                    onflag = true;
                    onjoin = false;
                } else {
                    onflag = false;
                    if (
                        candidate.on_boarding_date &&
                        !candidate.joining_date &&
                        candidate.status !== 'Hold'
                    ) {
                        onjoin = true;
                    } else {
                        onjoin = false;
                    }
                }
            }
            setunholdFlag(unhold);
            setholdFlag(!unhold);
            setJoiningDateFlag(onjoin);
            setOnboardFlag(onflag);

            setSample(!sample);
        } catch (e) {
            throw e;
        }
    };
    //PC_O_10,PC_OS_18
    //Bind the onboarding candidate in the Onboarding Grid
    let bindGridData = () => {
        return OnboardingCandidate.map((value, index) => {
            let onboardingDate;
            let joiningDate;
            if (value.on_boarding_date !== null) {
                onboardingDate = moment(new Date(value.on_boarding_date)).format('MMM DD, YYYY');
            } else {
                onboardingDate = 'NA';
            }
            if (value.joining_date !== null) {
                joiningDate = moment(new Date(value.joining_date)).format('MMM DD, YYYY');
            } else {
                joiningDate = 'NA';
            }
            let onboard = 'onboard';
            return (
                <tr key={index} className="hive-table-data regular-text align-middle">
                    <td className="align-items-center">
                        <input
                            className="form-check-input mt-0 recruitemt-input-checkbox"
                            type="checkbox"
                            id={value.id}
                            onChange={(e) => handleCheckbox(e, index, '')}
                            checked={checkedIds.includes(OnboardingCandidate[index].id)} />
                    </td>
                    <td>
                        <div className="d-flex align-items-center">
                            <img
                                src={value.candidate_photo_url}
                                alt="profile-img"
                                className="table-image"
                                style={{ width: '50px', height: '50px', borderRadius: '30px' }}
                            />
                            <div className="ms-2">
                                <a
                                    href={`/Recruitment/CandidateView?id=${value.id}&exp=${value.id.includes('E') ? `Experienced` : `Fresher`
                                        }&jId=${value.job_id}&val=${onboard}`}
                                    className="table-name-style semibold-text mb-0"
                                >
                                    {value.first_name + ' ' + value.last_name}
                                </a>
                            </div>
                        </div>
                    </td>
                    <td>{value.id}</td>
                    <td>
                        {(() => {
                            let displayText = '';
                            let fullText = '';

                            if (value.source_id === 1) {
                                displayText = `${value.job_source_name || ''} - ${value.college_name || ''}`;
                            } else if (value.source_id === 2) {
                                displayText = `${value.job_source_name || ''} - ${value.interview_source || ''}`;
                            } else if (value.source_id === 3) {
                                displayText = `${value.job_source_name || ''} - ${value.employee_name || ''}`;
                            } else {
                                displayText = value.job_source_name || '';
                            }

                            fullText = displayText;

                            if (displayText.length > 18) {
                                displayText = displayText.substring(0, 18) + '...';
                            }

                            return (
                                <span title={fullText}>
                                    {displayText}
                                </span>
                            );
                        })()}
                    </td>
                    <td>{value.job_position}</td>
                    <td>{value.annual_ctc}</td>
                    <td>{value.offerletter_status == null ? 'Not drafted' : value.offerletter_status}</td>

                    <td>{onboardingDate}</td>
                    <td>{value.document_verification == null ? 'Pending' : value.document_verification}</td>
                    <td>{joiningDate}</td>

                    {/* <td>{value.status == 'Not Joining'} </td> */}
                    {/* <td>
                    {value.status === 'Not Joining' ? (
                         <div>
                    {value.status == null ? 'Active' : value.status}
                   
                   
                        
                            <Tooltip text={value.reason || "No reason provided"}>
                            <img class="ms-1" src="/Images/tool-tip-icon.svg" alt="tooltip-icon"/>
                                
                            </Tooltip>
                            </div>
                        ) : (
                            <div>
                            {value.status == null ? 'Active' : value.status}
                            </div>
                        )}
                    </td> */}
                    {/* <td>
                    {(value.status === 'Not Joining') ? (
        <div style={{ display: 'flex', alignItems: 'center' }}>
           {value.status == null ? 'Active' : value.status}
            <Tooltip text={value.reason || "No reason provided"}>
                <img 
                    className="ms-1" 
                    src="/Images/tool-tip-icon.svg" 
                    alt="tooltip-icon"
                    style={{ cursor: 'pointer' }}
                />
            </Tooltip>
        </div>
    ) : (
        <div>
            {value.status == null ? 'Active' : value.status}
        </div>
    )}
</td> */}
                    <td>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {value.status == null ? 'Active' : value.status}

                            {value.status == 'Not joining' ? <Tooltip title={value.not_joining_reason ? value.not_joining_reason : "No reason provided"} class="custom-table-tooltip font-12">
                                <img class="ms-1" src="/Images/tool-tip-icon.svg" alt="tooltip-icon" /> </Tooltip> : <></>}

                        </div>
                    </td>




                </tr>
            );
        });
    };
    //PC_OS_11
    //This method is invoked when the user enters the value in the search field
    let getSearch = (e) => {
        try {
            setSearchValue(e.target.value);
        } catch (e) {
            throw e;
        }
    };
    //PC_OS_11
    //This method is invoked when the user enters the value in the search bar and clicks the enter button
    let enterSearch = (e) => {
        try {
            if (e.keyCode == 13) {
                searchClick();
            }
        } catch (e) {
            throw e;
        }
    };
    //PC_OS_11,PC_OS_12
    //This method is invoked when the user enters the values in the search field and click the search icon
    let searchClick = () => {
        try {
            if (searchValue !== '' || searchValue !== 'undefined') {
                getSearchData(searchValue).then((res) => {
                    if (res.data.statusCode == 200) {
                        setOnboardingCandidate(res.data.data);
                        setFilteredCount(res.data.data.length);
                        // setGridDataCount(res.data.totalCount);
                    }
                });
                bindGridData();
            } else {
                getOnboardingDetails();
                bindGridData();
            }
        } catch (e) {
            throw e;
        }
    };
    //PC_H_01,PC_H_07
    //This method is invoked when the user clicks the Hold button in Action bar
    const hold = async (value) => {
        try {
            let candidate_id_array = [];
            for (let i = 0; i < checkArray.length; i++) {
                if (checkArray[i] == true) {
                    candidate_id_array.push(OnboardingCandidate[i].id);
                }
            }
            let obj = { candidate_id: candidate_id_array, status: value };

            const res = await updateHoldOnboarding(obj);
            if (res.data.Success == true) {
                // Update the OnboardingCandidate state
                const updatedCandidates = OnboardingCandidate.map(candidate => {
                    if (candidate_id_array.includes(candidate.id)) {
                        return { ...candidate, status: value };
                    }
                    return candidate;
                });
                setOnboardingCandidate(updatedCandidates);
    
                // Reset checkbox state
                setHideBar(true);
                clearChecked();
                setCheckedIds([]);
                setSelectedCandidates([]);
                
                // Refresh the data
                getOnboardingDetails();
            }
        } catch (e) {
            console.error("Error in hold function:", e);
        }
    };

    //PC_AJ_01
    //This function is called when the user clicks the joining date button
    const joinClick = async (date, entity, times, address, floor) => {
        try {
            let time = moment(times, ['h:mm A']).format('hh:mm A');

            let entityvalue = { entity: entity };

            let val = await getEntityId(entityvalue);
            val = val.data.data[0].emp_id;
            let lastNum = parseInt(val.toString().replace(entity, ''));
            let candidate_id_array = [];
            let candidate_email_id = [];
            let emp_id_array = [];
            for (let i = 0; i < checkArray.length; i++) {
                if (checkArray[i] == true) {
                    lastNum = lastNum + 1;
                    let empid = entity + lastNum;
                    //await sendMail({ data: 'Your joining date is ' + date });
                    candidate_id_array.push(OnboardingCandidate[i].id);
                    candidate_email_id.push(OnboardingCandidate[i].email_id);
                    emp_id_array.push(empid);
                    let venue;
                    if (address == 'Bayline') {
                        venue = `${floor}, Block 2, Sandhya Infocity, Navalur, Chennai 600130`;
                    } else if (address == 'SSPDL') {
                        venue = `Alpha City (SSPDL), ${floor}, Beta Block, Navalur, Chennai  600130`;
                    } else {
                        venue = `${address}, ${floor}`;
                    }
                    let content = {
                        Subject: `AVASOFT-Joining`,
                        body: `<html lang="en">
    
                        <head>
                          <meta charset='utf-8'>
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                          <title>Invite User</title>
                        </head>
                        
                        <body>
                          <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                           <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                             <img src="https://www.avasoft.com/wp-content/uploads/2021/05/logo.png" alt="logo" style="width: 120px;">
                            </div>
                           </div>
                        
                           <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                           <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                            <h3 style=" font-size: 20px; color: #F29B10;">
                            Dear Candidate,
                            </h3>
                            <p style=" font-size: 16px; color: #0f0f0f;">
                            As discussed, your onboarding date is going to be on ${date}<br/><br/>
                          
                          
                          
                            Timing: ${time}<br/>
                            
                            Venue: ${venue}<br/><br/>
                            
                             
                            
                            AVASOFT welcomes you and wishes you Best luck!!!<br/><br/>
                            
                             
                            
                            Looking forward to Onboard you.<br/><br/>
                            Kindly follow the link  <a href="https://hivecandidate.avasoft.com?id=${OnboardingCandidate[i].job_id}">https://hivecandidate.avasoft.com?id=${OnboardingCandidate[i].job_id}</a> for more details.
                          </p>
                          <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                           Yours Truly,
                           </p>
                          <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                           Team Avasoft
                           </p>
                           </div>
                          </div>
                          
                        </div>
                        </body>
                        </html>`,
                        to: [OnboardingCandidate[i].email_id],
                    };
                    sendMail(content);
                }
            }

            //sendMail({ data: 'Your joining date is ' + date });
            let obj = { candidate_id: candidate_id_array, joining_date: date, join_time: time, join_address: address };
            let obj1 = { candidate_id: candidate_id_array, entity: entity, emp_id: emp_id_array };
            postEntity(obj1).then((res) => {
                if (res.data.Success == true) {
                }
            });
            updateJoiningDate(obj).then((res) => {
                if (res.data.Success == true) {
                    setHideBar(!hideBar);
                    getOnboardingDetails();
                    clearChecked();
                }
            });
            let data1 = {
                candidate_id: candidate_id_array,
                stage: 'Hire',
                stages: 'Hire',
            };
            postHireStage(data1).then((res) => {
                if (res.data.statusCode == 200) {
                }
            });
            let reason = `Hired by ${UserName}`;

            let payload = {
                icon_category: 'Hired',

                audit_reason: reason,
                candidate_id: candidate_id_array,
            };

            let response1 = await postHireTimeline(payload);
        } catch (e) {
            throw e;
        }
    };

    //PC_AO_01,PC_AO_07
    //This method is invoked when the user  clicks the  onboard button
    const onboardClick = async (date, times, address) => {
        try {
            let candidate_id_array = [];
            let time = moment(times, ['h:mm A']).format('hh:mm A');

            for (let i = 0; i < checkArray.length; i++) {
                if (checkArray[i] == true) {
                    // await sendMail({ data: 'Your onboarding date is ' + date });
                    let venue;
                    if (address == 'Bayline') {
                        venue = `Block 2, Sandhya Infocity, Navalur, Chennai 600130`;
                    } else if (address == 'SSPDL') {
                        venue = `Alpha City (SSPDL), Beta Block, Navalur, Chennai  600130`;
                    }
                    else {
                        venue = `${address}`;
                    }
                    candidate_id_array.push(OnboardingCandidate[i].id);
                    let content = {
                        Subject: `AVASOFT-Onboarding Formalities`,
                        body: `<html lang="en">
    
                        <head>
                          <meta charset='utf-8'>
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                          <title>Invite User</title>
                        </head>
                        
                        <body>
                          <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                           <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                             <img src="https://www.avasoft.com/wp-content/uploads/2021/05/logo.png" alt="logo" style="width: 120px;">
                            </div>
                           </div>
                        
                           <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                           <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                            <h3 style=" font-size: 20px; color: #F29B10;">
                            Dear Candidate,
                            </h3>
                            <p style=" font-size: 16px; color: #0f0f0f;">
                            We require the following documents as a part of joining formalities.<br/>
                          Kindly upload the softcopies of these documents before ${time} and ${date}.<br/><br/>
                       
                          1)SSLC/10th Std. Mark Sheet* <br/>
                          2)HSC/12th Std. Mark Sheet*<br/>
                          3)UG/PG Mark-Sheets<br/>
                          4)Certification (if any)<br/>
                          5)Aadhar Card (Must)<br/>
                          6)Pan Card (Must)<br/>
                          7)Driving License<br/>
                          8)Voter ID<br/>
                          9)Passport Size Photograph<br/>
                          10)Vaccination Certificate<br/><br/>
                           
                          
                          Note: Send us the documents which you hold <br/><br/>
                          
                          
                          
                          Onboarding Date: ${date} and ${time}<br/>
                          Venue:${venue}<br/><br/>
                          
                          
                          
                          Feel free to reach us through the numbers below in case of any clarifications:<br/><br/>
                          
                          1)Aishwarya K +91 91500 50213<br/>
2)Nandhini +91 95974 47200<br/>
3)Vishnu Priya +91 91505 22247<br/>
4)Raksha +91 91500 20110<br/><br/>
                          Kindly follow the link <a href="https://hivecandidate.avasoft.com?id=${OnboardingCandidate[i].job_id}">https://hivecandidate.avasoft.com?id=${OnboardingCandidate[i].job_id}</a>for more details.
                          </p>
                          <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                           Yours Truly,
                           </p>
                          <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                           Team Avasoft
                           </p>
                           </div>
                          </div>
                          
                        </div>
                        </body>
                        </html>`,
                        to: [OnboardingCandidate[i].email_id],
                    };

                    sendMail(content);
                }
            }
            let obj = { candidate_id: candidate_id_array, onboarding_date: date, on_board_time: times, address: address };

            updateOnboardingDate(obj).then((res) => {
                if (res.data.Success == true) {
                    setHideBar(!hideBar);
                    getOnboardingDetails();
                    clearChecked();
                }
            });
        } catch (e) {
            throw e;
        }
    };
    //PC_M_01,PC_M_07
    //This method is invoked when the user clicks the mark as not join button
    /**
     * PS_08 - PS_10 -- notJoinClick is triggered, where a popup will display
     */
    const notJoinClick = () => {
        setIsPopupVisible(true);

    };
    const closePopup = () => {
        setIsPopupVisible(false);
        setIssubmitted(false);
        setReason('');
    };
    const [issubmitted, setIssubmitted] = useState(false);
    // const submitReason = () => {
    //     if (reason.length > 0) {
    //         closePopup();
    //         return;
    //     }
    //     setIssubmitted(true);
    // };
    /**
     * PS_23 -- updateMarkAsNotJoin will get triggered
     */
    const submitReason = async () => {
        if (reason.length > 0) {


            setNotJoiningReason(reason);

            let candidate_id_arrays = [];

            for (let i = 0; i < checkArray.length; i++) {
                if (checkArray[i] === true) {
                    candidate_id_arrays.push(OnboardingCandidate[i].id);
                }
            }

            let obj = { candidate_id: candidate_id_arrays, reason: reason };

            try {
                //debugger;
                const res = await updateMarkAsNotJoin(obj);
                if (res.data.Success === true) {
                    setHideBar(!hideBar);
                    clearChecked();
                    setCheckedIds([]); // Clear checked IDs
                    setSelectedCandidates([]); // Clear selected candidates
                    getOnboardingDetails();
                }
            } catch (error) {
                console.error("Error updating not joining status:", error);
            }

            closePopup();
        } else {
            setIssubmitted(true);
        }
    };

    const handleExportExcel = async () => {

        try {
            let exportToExcel = [
                [
                    "Candidate Name",
                    "Candidate ID",
                    "Source",
                    "Job Position",
                    "CTC",
                    "Offer Status",
                    "Onboarding Date",
                    "Document Status",
                    "Joining Date",
                    "Status",
                    "Reason",
                ],
            ];


            for (var i = 0; i < OnboardingCandidate.length; i++) {
                let onboardingDate = OnboardingCandidate[i].on_boarding_date
                    ? moment(OnboardingCandidate[i].on_boarding_date).format('YYYY-MM-DD')
                    : 'NA';
                let joiningDate = OnboardingCandidate[i].joining_date
                    ? moment(OnboardingCandidate[i].joining_date).format('YYYY-MM-DD')
                    : 'NA';

                let val = [
                    OnboardingCandidate[i].first_name + ' ' + OnboardingCandidate[i].last_name,
                    OnboardingCandidate[i].id,
                    OnboardingCandidate[i].job_source_name,
                    OnboardingCandidate[i].job_position,
                    OnboardingCandidate[i].annual_ctc,
                    OnboardingCandidate[i].offerletter_status || 'Not drafted',
                    onboardingDate,
                    OnboardingCandidate[i].document_verification || 'Pending',
                    joiningDate,
                    OnboardingCandidate[i].status || 'Active',
                    (OnboardingCandidate[i].status === 'Not joining' ?
                        (OnboardingCandidate[i].not_joining_reason || "No reason provided") : 'NA')
                ];
                exportToExcel.push(val);
            }

            let filename = "Onboarding"
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const fileExtension = '.xlsx';
            let ws = XLSX.utils.aoa_to_sheet(exportToExcel);
            const wb = { Sheets: { 'Onboarding': ws }, SheetNames: ['Onboarding'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data1 = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data1, filename + fileExtension);
            setIsLoading(true);
        } catch (error) {
            console.error("Error exporting to Excel:", error);
            throw error;
        }
    };


    //PC_OF_09
    //This method is invoked when the user clicks the clear button in the filter
    const clearFilter = () => {
        try {
            //
            setStatus('');
            setonboardingStatus('');
            setjoiningStatus('');
            setCtc('');
            setDocStatus('');
            setOfferStatus('');
            setSource('');
            setFromDate('');
            setToDate('');
            getOnboardingDetails();
            setSelectedColleges([]);
        } catch (e) { }
    };
    //PC_AB_05
    //This method is invoked when the user unchecks the checkbox in onboarding grid
    const clearChecked = () => {
        let checkboxArray = new Array(OnboardingCandidate.length).fill(false);
        setallCheck(false);
        setCheckArray(checkboxArray);
    };
    //PC_OF_01,PC_OF_02,PC_OF_08
    //This method is invoked when the user clicks the apply button in apply button
    /**
     * PS_OD_06 - PS_OD_15 - When th euser Clicks From Data and To Date in filter and click applt button
     *                       If No filters are set getOnboardingDetails() function will call
     * PS_OD_08 - PS_OD_24 - If filters are set it will be store in filterString and send to getFilterData
     *                       and store in setOnboardingCandidate()
     */
    // const applyFilter = () => {

    //     try {
    //         let filterString = {};
    //         if (status == '' && onboardingStatus == '' && joiningStatus == '' && ctc == '' && docStatus == '' && offerStatus == '' && fromDate == '' && toDate == '' && source == '' && selectedColleges == '') {
    //             getOnboardingDetails();
    //         } else {
    //             if (status != '') {
    //                 filterString['f.status'] = status;
    //             }
    //             if (onboardingStatus != '') {
    //                 filterString['onboardingStatus'] = onboardingStatus;
    //             }
    //             if (joiningStatus != '') {
    //                 filterString['joiningStatus'] = joiningStatus;
    //             }

    //             if (ctc != '') {
    //                 filterString['annual_ctc'] = ctc;
    //             }
    //             if (docStatus != '') {
    //                 if (docStatus == 'Pending') {
    //                     filterString['d.status'] = null;
    //                 } else {
    //                     filterString['d.status'] = docStatus;
    //                 }
    //             }
    //             if (offerStatus != '') {
    //                 filterString['offerletter_status'] = offerStatus;
    //             }

    //             if (selectedColleges.length > 0) {
    //                 filterString['college'] = selectedColleges;
    //             }
    //             if (source != '') {
    //                 filterString['job_source_name'] = source;
    //             }
    //             if (fromDate != '') {
    //                 filterString['fromDate'] = fromDate;
    //             }
    //             if (toDate != '') {
    //                 filterString['toDate'] = toDate;
    //             }

    //             getFilterData(filterString).then((res) => {
    //                 if (res.data.statusCode == 200) {
    //                     setOnboardingCandidate(res.data.data);
    //                     setGridDataCount(res.data.totalCount);
    //                 }
    //                 else {
    //                     setOnboardingCandidate([]);
    //                     setGridDataCount(0);
    //                 }
    //             }).catch(error => {
    //                 console.error("Error applying filters:", error);
    //                 setOnboardingCandidate([]);
    //                 setGridDataCount(0);
    //             });
    //         }
    //     } catch (err) {
    //         console.error("Error in applyFilter:", err);
    //         setOnboardingCandidate([]);
    //     }
    // };

    const applyFilter = () => {

        try {
            let filterString = {};
            if (status === '' && onboardingStatus === '' && joiningStatus === '' && ctc === '' && docStatus === '' && offerStatus === '' && fromDate === '' && toDate === '' && source === '' && selectedColleges.length === 0) {
                getOnboardingDetails();
            } else {
                if (status !== '') filterString['f.status'] = status;
                if (onboardingStatus !== '') filterString['onboardingStatus'] = onboardingStatus;
                if (joiningStatus !== '') filterString['joiningStatus'] = joiningStatus;
                if (ctc !== '') filterString['annual_ctc'] = ctc;
                if (docStatus !== '') {
                    filterString['d.status'] = docStatus === 'Pending' ? null : docStatus;
                }
                if (offerStatus !== '') filterString['offerletter_status'] = offerStatus;
                if (selectedColleges.length > 0) filterString['college'] = selectedColleges;
                if (source !== '') filterString['job_source_name'] = source;
                if (fromDate !== '') filterString['fromDate'] = fromDate;
                if (toDate !== '') filterString['toDate'] = toDate;


                getFilterData(filterString).then((res) => {
                    if (res.data.statusCode === 200) {
                        setOnboardingCandidate(res.data.data);
                        setFilteredCount(res.data.data.length);
                        // Uncomment the next line if your API returns a total count
                        // setGridDataCount(res.data.totalCount);
                    } else {
                        setOnboardingCandidate([]);
                        setFilteredCount(0);
                    }
                }).catch(error => {
                    console.error("Error applying filters:", error);
                    setOnboardingCandidate([]);
                    setFilteredCount(0);
                });
            }
        } catch (err) {
            console.error("Error in applyFilter:", err);
            setOnboardingCandidate([]);
            setFilteredCount(0);
        }
    };

    //PC_O_S_01,PC_O_S_02
    //This method is triggered when the user clicks the sort icon
    const sortIconClick = (e) => {
        try {
            setHideSortIcon({
                ...hideSortIcon,
                [e.target.id.split('-')[0]]: e.target.id.split('-')[1],
            });
            var sortImageId = e.target.id.split('-');
            setColumnName(sortImageId[0]);
            setSortOrder(sortImageId[1]);
            setColumnSearch('order by ' + sortImageId[0] + ' ' + sortImageId[1]);
            let sort = 'order by ' + sortImageId[0] + ' ' + sortImageId[1];
            getSortData(sort).then((res) => {
                if (res.data.statusCode == 200) {
                    setOnboardingCandidate(res.data.data);
                }
            });
        } catch (err) {
            throw err;
        }
    };

    const handleTotalCountClick = () => {

        setShowPopup(true);
    };
    return (
        <div className="container-fluid">
            <div className="row mt-3">
                <BreadCrumbs data={breadCrumbsData} />
                {/*jobs tab  */}
                <div className="tab-pane fade show active mt-4" id="candidate" role="tabpanel" aria-labelledby="#candidate">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-between mb-4">
                            <div className="bold-text">Onboarding</div>
                            <div className="ms-auto d-flex">
                                <div className="input-group flex-nowrap search-group me-3">
                                    <input
                                        type="search"
                                        className="form-control search-align "
                                        placeholder="Search"
                                        value={searchValue}
                                        onKeyDown={(e) => {
                                            enterSearch(e);
                                        }}
                                        onChange={(e) => getSearch(e)}
                                    />
                                    <button
                                        className="input-group-text btn btn-search-custom "
                                        onClick={() => {
                                            searchClick();
                                        }}
                                    >
                                        <img src="/Images/search-icon.svg" alt="search-icon" />
                                    </button>
                                </div>
                            </div>

                            <div className="dropdown">
                                <button
                                    className="advanced-filter-button me-3 medium-text"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    aria-expanded="false"
                                    onClick={() => setFilterShow(!filterShow)}
                                >
                                    <img src="/Images/filter-icon.svg" alt="Filter-icon" className="me-2" />
                                    Filter
                                </button>
                                {filterShow && (
                                    <div className="dropdown-menu custom-dropdown px-3 advanced-filter-panel show">
                                        <div className="row">
                                            <div className="col-md-12 py-2 border-0 mb-1">
                                                <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>
                                                <button
                                                    type="button"
                                                    className="btn-close float-end close-filter"
                                                    onClick={() => setFilterShow(false)}
                                                />
                                            </div>
                                            <div className="col-md-12 ">
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="Domain">
                                                            CTC
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            aria-label="Default select example2"
                                                            value={ctc}
                                                            id="Domain"
                                                            onChange={(e) => {
                                                                setCtc(e.target.value);
                                                            }}
                                                            placeholder="Enter CTC"
                                                        />
                                                        {/* <select
                                                            className=""
                                                            aria-label="Default select example2"
                                                            value={ctc}
                                                            id="Domain"
                                                            onChange={(e) => {
                                                                setCtc(e.target.value);
                                                            }}
                                                        >
                                                            <option>Select</option>
                                                            <option value={4}>4 LPA</option>
                                                            <option value={5}>5 LPA</option>
                                                            <option value={6}>6 LPA</option>
                                                        </select> */}
                                                    </div>
                                                    <div className="col-md-6 mb-3 ">
                                                        <label className="form-label hive-form-label" htmlFor="Approval_status">
                                                            Offer Status
                                                        </label>
                                                        <select
                                                            className="form-select hive-form-select"
                                                            aria-label="Default select example2"
                                                            id="Approval_status"
                                                            value={offerStatus}
                                                            onChange={(e) => {
                                                                setOfferStatus(e.target.value);
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Not Drafted">Not Drafted</option>
                                                            <option value="Offer Drafted">Offer Drafted</option>

                                                            <option value="Offer Send">Offer Send</option>
                                                            <option value="Offer Accepted">Offer Accepted</option>
                                                            <option value="Offer Rejected">Offer Rejected</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 ">
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="Domain">
                                                            Onboarding Status
                                                        </label>
                                                        <select
                                                            className="form-select hive-form-select"
                                                            aria-label="Default select example2"
                                                            id="Domain"
                                                            onChange={(e) => {
                                                                setonboardingStatus(e.target.value);
                                                            }}
                                                            value={onboardingStatus}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Announced">Announced</option>
                                                            <option value="Yet to Announce">Yet to Announce</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3 ">
                                                        <label className="form-label hive-form-label" htmlFor="Approval_status">
                                                            Document Status
                                                        </label>
                                                        <select
                                                            className="form-select hive-form-select"
                                                            aria-label="Default select example2"
                                                            id="Approval_status"
                                                            onChange={(e) => {
                                                                setDocStatus(e.target.value);
                                                            }}
                                                            value={docStatus}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Pending">Pending</option>
                                                            <option value="Approved">Approved</option>
                                                            <option value="Rejected">Rejected</option>
                                                            <option value="Submitted">Submitted</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 ">
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="Domain">
                                                            Joining Status
                                                        </label>
                                                        <select
                                                            className="form-select hive-form-select"
                                                            aria-label="Default select example2"
                                                            id="Domain"
                                                            onChange={(e) => {
                                                                setjoiningStatus(e.target.value);
                                                            }}
                                                            value={joiningStatus}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Announced">Announced</option>
                                                            <option value="Yet to Announce">Yet to Announce</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3 ">
                                                        <label className="form-label hive-form-label" htmlFor="Approval_status">
                                                            Status
                                                        </label>
                                                        <select
                                                            className="form-select hive-form-select"
                                                            aria-label="Default select example2"
                                                            id="Approval_status"
                                                            onChange={(e) => {
                                                                setStatus(e.target.value);
                                                            }}
                                                            value={status}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Selected">Selected</option>
                                                            <option value="Hold">Hold</option>
                                                            <option value="Active">Active</option>
                                                            <option value="Block">Block</option>
                                                            <option value="Rejected">Rejected</option>
                                                            <option value="Not joining">Not joining</option>

                                                        </select>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-12 ">
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="College">
                                                            College
                                                        </label>
                                                        <Select
                                                            isMulti
                                                            name="college_name"
                                                            options={collegeOptions}
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            value={selectedColleges.map(college => ({ value: college.college_abbreviation, label: college.college_abbreviation }))}
                                                            onChange={handleCollegeChange}
                                                        />

                                                    </div>
                                                    <div className="col-md-6 mb-3 ">
                                                        <label className="form-label hive-form-label" htmlFor="source">
                                                            Source
                                                        </label>
                                                        <select
                                                            className="form-select hive-form-select"
                                                            aria-label="Default select example2"
                                                            id="source"
                                                            value={source}
                                                            onChange={(e) => {
                                                                setSource(e.target.value);
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Placement">Placement</option>
                                                            <option value="Walkin">Walkin</option>
                                                            <option value="Referral">Referral</option>

                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 py-2 border-0 mb-1">
                                                <span className="font-16 semibold-text advanced-filter-title">Joining Date Range</span>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="row mb-3">
                                                    <div className="col-md-6">
                                                        <label className="form-label hive-form-label" htmlFor="fromrange">
                                                            From
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control hive-form-control"
                                                            id="fromDate"
                                                            name="fromDate"
                                                            onChange={(e) => {
                                                                setFromDate(e.target.value);
                                                            }}
                                                            value={fromDate}
                                                            max={toDate}
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label hive-form-label" htmlFor="forange">
                                                            To
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control hive-form-control"
                                                            id="toDate"
                                                            name="toDate"
                                                            min={fromDate}
                                                            onChange={(e) => {
                                                                setToDate(e.target.value);
                                                            }}
                                                            value={toDate}

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 my-3 d-flex justify-content-end">
                                                <button className="btn hive-btn-secondary me-3" onClick={clearFilter}>
                                                    Clear
                                                </button>
                                                <button className="btn hive-btn-primary" onClick={() => { setFilterShow(false); applyFilter(); }}>
                                                    Apply
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <button
                            className="btn hive-btn-outline me-3"
                            style={{
                                position: 'relative',
                                top: '-63px',
                                right: '10px',
                                left: '976px',
                                padding: '5px 10px',

                            }}
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={(e) => handleExportExcel(e)}
                        >
                            Export to Excel
                        </button>

                        <div className="table-responsive rounded-3">
                            {OnboardingCandidate.length > 0 ? (
                                <>
                                    <table className="table bg-white hive-grid table-borderless ">
                                        <thead className="hive-table-head ">
                                            <tr>
                                                <th className="hive-header-th">
                                                    <input
                                                        className="form-check-input mt-0 recruitemt-input-checkbox"
                                                        type="checkbox"
                                                        name="all"
                                                        checked={allCheck}
                                                        onChange={(e) => handleCheckbox(e, '', 'all')}
                                                    />
                                                </th>
                                                <th className="bold-text font-12 hive-header-th">
                                                    Candidate Name
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="first_name-asc"
                                                            hidden={hideSortIcon.first_name == 'desc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="first_name-desc"
                                                            hidden={hideSortIcon.first_name == 'asc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12 hive-header-th">
                                                    Candidate ID
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="id-asc"
                                                            hidden={hideSortIcon.id == 'desc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="id-desc"
                                                            hidden={hideSortIcon.id == 'asc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12 hive-header-th">
                                                    Source
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="job_source_name-asc"
                                                            hidden={hideSortIcon.job_source_name == 'desc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="job_source_name-desc"
                                                            hidden={hideSortIcon.job_source_name == 'asc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12 hive-header-th">
                                                    Job Position
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="job_position-asc"
                                                            hidden={hideSortIcon.job_position == 'desc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="job_position-desc"
                                                            hidden={hideSortIcon.job_position == 'asc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12 hive-header-th">
                                                    CTC
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="annual_ctc-asc"
                                                            hidden={hideSortIcon.annual_ctc == 'desc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="annual_ctc-desc"
                                                            hidden={hideSortIcon.annual_ctc == 'asc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12 hive-header-th">
                                                    Offer Status
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="offerletter_status-asc"
                                                            hidden={hideSortIcon.offerletter_status == 'desc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="offerletter_status-desc"
                                                            hidden={hideSortIcon.offerletter_status == 'asc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12 hive-header-th">
                                                    Onboarding Date
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="on_boarding_date-asc"
                                                            hidden={hideSortIcon.on_boarding_date == 'desc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="on_boarding_date-desc"
                                                            hidden={hideSortIcon.on_boarding_date == 'asc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12 hive-header-th">
                                                    Document Status
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="document_verification-asc"
                                                            hidden={hideSortIcon.document_verification == 'desc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="document_verification-desc"
                                                            hidden={hideSortIcon.document_verification == 'asc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12 hive-header-th">
                                                    Joining Date
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="joining_date-asc"
                                                            hidden={hideSortIcon.joining_date == 'desc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="joining_date-desc"
                                                            hidden={hideSortIcon.joining_date == 'asc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12 hive-header-th">
                                                    Status
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="status-asc"
                                                            hidden={hideSortIcon.status == 'desc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="status-desc"
                                                            hidden={hideSortIcon.status == 'asc' ? false : true}
                                                            onClick={(e) => {
                                                                sortIconClick(e);
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>{bindGridData()}</tbody>
                                    </table>
                                    <div className="record-count-info">
                                        <p># of Records: {filteredCount} out of {gridDataCount}</p>
                                    </div>

                                    <div className="text-center mb-3">
                                        <button className="btn show-more-btn" hidden>
                                            {' '}
                                            show more
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <div className="row justify-content-center">
                                    <img src="/Images/nodatafound.png" alt="no-records" style={{ width: '750px', height: '500px' }} />
                                    <span className="row justify-content-center">No Candidate Found</span>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="container-fluid" hidden={hideBar == true ? true : false}>
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center d-flex align-items-center justify-content-between Todo-Strip-bg Strip-bot">
                                <img
                                    onClick={(e) => {
                                        clearChecked();
                                        setCheckedIds([])
                                        setSelectedCandidates([])
                                        setHideBar(!hideBar);
                                    }}
                                    src="/Images/Todo-stripe-close.svg"
                                    alt="Closebutton"
                                />
                                <p className="todo-Font-White mb-0">
                                    <span className="todo-count font-18 semibold-text me-2" onClick={handleTotalCountClick}>{count}</span>
                                    Candidate Selected
                                </p>

                                {holdflag && (
                                    <button
                                        className="btn todo-btn font-14 semibold-text"
                                        onClick={() => {
                                            hold('Hold');
                                        }}
                                    >
                                        <img src="/Images/Selectall-todo.svg" className="me-3" />
                                        Hold
                                    </button>
                                )}
                                {unholdflag && (
                                    <button
                                        className="btn todo-btn font-14 semibold-text"
                                        onClick={() => {
                                            hold('Active');
                                        }}
                                    >
                                        <img src="/Images/Selectall-todo.svg" className="me-3" />
                                        UnHold
                                    </button>
                                )}
                                {JoiningDateFlag && (
                                    <button
                                        className="btn todo-btn font-14 semibold-text"
                                        data-bs-toggle="modal"
                                        data-bs-target="#exampleModalJoin"
                                    >
                                        <img src="/Images/onboarding-date.svg" className="me-3" />
                                        Announce Joining Date
                                    </button>
                                )}
                                {OnboardFlag && (
                                    <button
                                        className="btn todo-btn font-14 semibold-text"
                                        data-bs-toggle="modal"
                                        data-bs-target="#exampleModal"
                                    // onClick={() => {
                                    //   onboardClick();
                                    // }}
                                    >
                                        <img src="/Images/onboarding-date.svg" className="me-3" />
                                        Announce Onboarding Date
                                    </button>
                                )}
                                {addFlag && (
                                    <button className="btn todo-btn font-14 semibold-text">
                                        <img src="/Images/Duplicate.svg" className="me-3" />
                                        Add as team member
                                    </button>
                                )}
                                {/*PS_07 - PS_08 -- When user clicks on this button */}
                                <button
                                    className="btn todo-btn font-14 semibold-text"
                                    onClick={() => {
                                        notJoinClick();
                                    }}
                                >
                                    <img src="/Images/not-joining.svg" className="me-3" />
                                    Mark as not joining
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        {/* <button onClick={notJoinClick}>Not Joining</button> */}
                        {/*PS_14 - PS_16 -- Whenuser clicks on the close button which navigates to the Onboarding.jsx */}
                        {isPopupVisible && (
                            <div className="popup-overlay">
                                <div className="popupp">
                                    <button
                                        className="popup-close-btn"
                                        onClick={closePopup}
                                        style={{
                                            position: 'absolute',
                                            top: '10px',
                                            right: '10px',
                                            border: 'none',
                                            background: 'transparent',
                                            fontSize: '20px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        &times;
                                    </button>
                                    <h2>Not Joining</h2>
                                    <h3>Reason for not joining</h3>
                                    <textarea
                                        placeholder="Enter Reason"
                                        rows="4"
                                        value={reason}
                                        onChange={(e) => setReason(e.target.value)}
                                    ></textarea>
                                    {/*PS_11 - PS_13 -- User clicks on Cancel button which navigate to the Onboarding.jsx*/}
                                    <a onClick={closePopup} style={{ position: 'relative', left: '211px', top: '28px', cursor: 'pointer' }}>Cancel</a>
                                    {/* <div className="popup-buttons" > */}
                                    {/*PS_17 - PS_22 When user clicks on the submit where the valid reason needs to be provided */}

                                    <button className="popup-buttons" style={{ padding: '5px 10px', backgroundColor: '#F29B10', color: 'white', border: 'none', borderRadius: '3px', cursor: 'pointer', width: '73px', position: 'relative', left: '279px' }} onClick={() => {
                                        submitReason();
                                    }}>Submit</button>
                                    {reason.length === 0 && issubmitted ?
                                        <p className='P'>Please enter the reason before submit</p>
                                        : null
                                    }
                                    {/* </div> */}
                                </div>
                            </div>
                        )}

                    </div>

                </div>
            </div>
            {
                showPopup ? (
                    <OnboardingPopupGrid
                        selectedCandidates={selectedCandidates}
                        setSelectedCandidates={setSelectedCandidates}
                        setHideBar={setHideBar}
                        setShowPopup={setShowPopup}
                        checkedIds={checkedIds}
                        setCheckedIds={setCheckedIds}
                        setCount={setCount}
                        setAllCheck={setallCheck}
                        OnboardingCandidate={OnboardingCandidate}
                        setUnholdFlag={setunholdFlag}
                        setHoldFlag={setholdFlag}
                        setJoiningDateFlag={setJoiningDateFlag}
                        setOnboardFlag={setOnboardFlag}
                        setSample={setSample}
                        candidateRecords={OnboardingCandidate} // Pass the full list of candidates for reference
                        setCandidateRecords={setCandidateRecords} // Pass the full list of candidates for reference
                    />

                ) : <></>
            }
            <Popup
                onBoarding={(date, time, address, floor) => {
                    onboardClick(date, time, address, floor);
                }}
            />
            <JoinPopup
                joining={(date, entity, time, address, floor) => {
                    joinClick(date, entity, time, address, floor);
                }}
            />
        </div >
    );
}
export default Onboarding;
